var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')
module.exports = {
  props: {
    taskSetting: Object,
  },

  data: function () {
    return {
      printerList: [],
      printerInfo: {price:{}},
    }
  },

  compiled: function() {
    getPrinterList(this)
  },

  methods: {
    showPrinterInfo: function() {
      getPrinterDetail(this)
    },
  },

  components: {
    'custom-select': require('../controls/custom-select.vue'),
    'custom-switch': require('../controls/custom-switch.vue'),
  }
}

function getPrinterList(vuemodel) {
  yy_request.rest_api({
    method: 'get',
    api: 'printers/?sch_id='+po.userinfo.sch_id,
    opSuccess: function(info) {
      for(var i in info) {
        vuemodel.printerList.push({
          text: info[i].name+' 【'+info[i].address+'】',
          value: info[i].id,
        })
      }
    },
  })
}

function getPrinterDetail(vuemodel) {
  yy_request.rest_api({
    method: 'get',
    api: 'printers/'+vuemodel.taskSetting.printerId,
    opSuccess: function(info) {
      vuemodel.printerInfo=info;
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/task-setting.vue
// module id = 144
// module chunks = 0